import { gql } from "@apollo/client";

export const GET_UNIVERSAL_BENCHMARKS_METADATA = gql`
  query GetUniversalBenchmarksMetadata {
    me {
      universalBenchmarksMetadata {
        minDate
        adoptedBenchmark {
          id
          baselineFilters
          selectedMetricIds
        }
      }
    }
  }
`;

export const GET_ADOPTED_UNIVERSAL_BENCHMARKS_METADATA = gql`
  query GetAdoptedUniversalBenchmarksMetadata {
    me {
      adoptedUniversalBenchmarksMetadata {
        id
        selectedMetricIds
      }
    }
  }
`;

export const GET_UNIVERSAL_BENCHMARKS_DAYS = gql`
  query GetUniversalBenchmarksDays(
    $attributionModel: String!
    $accountingMode: String!
    $attributionWindow: String!
    $dateRange: JSONObject!
  ) {
    me {
      universalBenchmarksDays(
        attributionModel: $attributionModel
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        dateRange: $dateRange
      )
      universalBenchmarksCancelledOrders(dateRange: $dateRange)
    }
  }
`;

export const ADOPT_UNIVERSAL_BENCHMARKS = gql`
  mutation AdoptUniversalBenchmarks(
    $baselineFilters: JSONObject!
    $selectedDays: [String!]!
    $metricIds: [String!]!
  ) {
    adoptUniversalBenchmarks(
      baselineFilters: $baselineFilters
      selectedDays: $selectedDays
      metricIds: $metricIds
    ) {
      successMessage
    }
  }
`;

export const DELETE_UNIVERSAL_BENCHMARKS = gql`
  mutation DeleteUniversalBenchmarks($id: String!) {
    deleteUniversalBenchmarks(id: $id)
  }
`;

export const GET_UNIVERSAL_BENCHMARKS_AD_SPEND_AGGREGATOR = gql`
  query GetUniversalBenchmarksAdSpendAggregator(
    $adoptedBenchmarkId: String
    $attributionModel: String!
    $accountingMode: String!
    $attributionWindow: String!
    $dateRange: JSONObject!
  ) {
    me {
      universalBenchmarksAdSpendAggregator(
        adoptedBenchmarkId: $adoptedBenchmarkId
        attributionModel: $attributionModel
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        dateRange: $dateRange
      ) {
        allSpend
        profitableSpend
        unprofitableSpend
        profitableSpendFt
        unprofitableSpendFt
        profitableSpendRtn
        unprofitableSpendRtn
      }
    }
  }
`;

export const GET_UNIVERSAL_BENCHMARKS_LEVEL_AGGREGATOR = gql`
  query GetUniversalBenchmarksLevelAggregator(
    $adoptedBenchmarkId: String
    $attributionModel: String!
    $accountingMode: String!
    $attributionWindow: String!
    $dateRange: JSONObject!
    $level: String!
  ) {
    me {
      universalBenchmarksLevelAggregator(
        adoptedBenchmarkId: $adoptedBenchmarkId
        attributionModel: $attributionModel
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        dateRange: $dateRange
        level: $level
      ) {
        totalRows
        profitableRows
        unprofitableRows
        profitableRowsFt
        unprofitableRowsFt
        profitableRowsRtn
        unprofitableRowsRtn
      }
    }
  }
`;

export const GET_UNIVERSAL_BENCHMARKS_TARGETS = gql`
  query GetUniversalBenchmarksTargets(
    $adoptedBenchmarkId: String!
    $level: String!
    $attributionModel: String!
    $accountingMode: String!
    $attributionWindow: String!
    $breakdowns: [String!]!
    $filters: [SalesTableReportV3BreakdownsFilterInput!]!
  ) {
    me {
      universalBenchmarksTargets(
        adoptedBenchmarkId: $adoptedBenchmarkId
        level: $level
        attributionModel: $attributionModel
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
        breakdowns: $breakdowns
        filters: $filters
      ) {
        rows
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;

export const GET_UNIVERSAL_BENCHMARKS_CONVERSION_LAG_REPORT = gql`
  query GetUniversalBenchmarksConversionLagReport(
    $selectedDays: [String!]!
    $attributionModel: String!
    $accountingMode: String!
  ) {
    me {
      universalBenchmarksConversionLagReport(
        selectedDays: $selectedDays
        attributionModel: $attributionModel
        accountingMode: $accountingMode
      ) {
        attributionWindow
        rev
      }
    }
  }
`;

export const GET_UNIVERSAL_BENCHMARKS_FUNNEL_REPORT = gql`
  query GetUniversalBenchmarksFunnelReport(
    $selectedDays: [String!]!
    $funnel: String!
    $accountingMode: String!
    $attributionWindow: String!
  ) {
    me {
      universalBenchmarksFunnelReport(
        selectedDays: $selectedDays
        funnel: $funnel
        accountingMode: $accountingMode
        attributionWindow: $attributionWindow
      ) {
        platform
        txns
      }
    }
  }
`;

export const GET_ADOPTED_UNIVERSAL_BENCHMARKS = gql`
  query GetAdoptedUniversalBenchmarks {
    me {
      adoptedUniversalBenchmarks {
        id
        createdAt
        userEmail
      }
    }
  }
`;
